import searchDepthItem from '../search-depth-item';

/**
 * Returns the filter condition data
 *
 * @param {Number} itemID The item ID
 * @return {Object} The item
 */
const getFilterCondition = ( itemID ) => {
	return searchDepthItem(
		UncannyAutomator._recipe.actions.items,
		itemID
	);
}

export default getFilterCondition;
